<script>
  import { onMount } from "svelte";
  import Header from "../../views/Header.svelte";

  let visible = false;

  onMount(() => {
    setTimeout(() => {
      visible = true;
    }, 50);
  });
</script>

<style lang="scss">
  .headline {
    display: flex;
    flex-direction: column;
    padding: 0 15em;
    opacity: 1;
    background: transparent url('../assets/aboutus-headline-bg.png') 0% 0% no-repeat padding-box;
    background-size: contain;
    height: 50em;

    visibility: hidden;
    opacity: 0;

    &.visible {
      transition: opacity 0.1s;
      visibility: visible;
      opacity: 1;
    }

    .headline__article {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: auto;
      margin-top: 5em;

      .headline__text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 60em;

        h3 {
          text-align: center;
        }
      }
    }
  }
</style>

<section class="headline" class:visible={visible}>
  <Header />
  <article class="headline__article">
    <section class="headline__text">
      <h3 class="header-title wc">Voltaware & Octopus Energy: What’s in it for you?</h3>
    </section>
  </article>
</section>
